import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

export default function LawAndPolicies(){
    const location = useLocation();
    const canonicalUrl = window.location.origin + location.pathname;

    return <div className="container">
    <Helmet>
      <title>سياسات ام بي تك</title>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
<div className="policy-img">
<img src={require('../assests/lawAndPolicies-AR.jpg')} alt='policy-img'/>
    </div>
    <div className='policies-container'>
    <p className='section-title'>قائمة الشروط والاحكام</p>
    <p><span>مرحبًا بكم في (MP TECH) . </span> نود أن نعلمك أن كافة البيانات التي ستقدمها عند شرائك أحد هذه الخدمات، ستكون في موجب السرية والخصوصية المطلقة، وأي إنتهاك يمس نزاهة فريق العمل أو اتهامهم، سيتم إتخاذ الإجراءات القانونية اللازمة. </p>
    <div className='policy-list'>
<p>-بإستخدامك لخدماتنا، فإنك تقر بأنك تبلغ من العمر القانوني ما يناسب قدرتك على الدخول في عقود ملزمة قانونًا.</p>
<p>-يتم تحديد جميع الرسوم والأسعار بشكل واضح في العقد بيننا وبين العميل.</p>
<p> -يجب دفع الرسوم في المواعيد المحددة. نحتفظ بالحق في تعليق أو إنهاء الخدمات في حالة التأخر في الدفع.</p>
<p>-يحق للعميل الإلغاء والسداد  في أي وقت ولكن قد يتم تطبيق رسوم الإلغاء
 لن يتم استرداد المدفوعات إلا في حالة وجود اتفاق مسبق بأنك ستقوم بالإلغاء.
</p>
<p>-جميع المحتويات والمواد المستخدمة أو المقدمة في إطار خدماتنا، بما في ذلك النصوص والرسومات والشعارات، هي ملكية حصرية لشركة <span>(MP TECH) </span>أو المرخصين التابعين لها. لا يجوز إعادة إنتاج أو استخدام هذه المواد دون إذن خطي مسبق .</p>
<p>-لا تتحمل الشركة المسؤولية عن أي ضرر أو خسائر قد تنشأ أثناء استخدام خدماتنا، مثل فقدان البيانات أو الأرباح .</p>
<p>- نحتفظ بالحق في تعديل هذه الشروط والأحكام في أي وقت. وسيتم إعلام العملاء بأي تغييرات عبر البريد الإلكتروني أو من خلال موقعنا الإلكتروني. يُعتبر استمرارك في استخدام الخدمات بعد هذه التعديلات قبولاً للشروط المعدلة .</p>
<p>-فترة السماح بتأخير السداد:
يمكن للشركة تقديم فترة سماح محددة بعد تاريخ استحقاق الدفع، مثلاً 7 إلى 14 يومًا. خلال هذه الفترة، يتم تذكير العميل بالدفع دون فرض أي غرامات .
</p>
<p>رسوم التأخير:
-بعد انتهاء فترة السماح، يمكن فرض رسوم تأخير. هذه الرسوم عادة ما تكون نسبة مئوية من المبلغ المستحق أو مبلغًا ثابتًا محددًا في العقد. على سبيل المثال، يمكن فرض رسوم تأخير بنسبة 2 % من المبلغ المستحق عن كل شهر تأخير .
</p>
<p>- إذا استمر التأخير في السداد بعد فترة السماح، قد تقوم الشركة بتعليق الخدمات المقدمة للعميل بشكل مؤقت حتى يتم استلام الدفعة. يمكن أن يشمل ذلك إيقاف حملات الإعلانات، أو إدارة الحسابات على وسائل التواصل الاجتماعي، أو إيقاف العمل على أي مشاريع قيد التنفيذ .</p>
<p>-في حال استمر التأخير لفترة طويلة، يمكن إرسال إشعار رسمي للعميل عبر البريد الإلكتروني أو البريد العادي، يوضح فيه المبلغ المستحق وضرورة السداد فورًا لتجنب إتخاذ إجراءات قانونية .</p>
<p>-إذا لم يتم السداد بعد الإجراءات السابقة، يمكن للشركة إلغاء العقد من جانب واحد. يجب أن يكون هذا الحق مذكورًا بوضوح في العقد الأصلي .</p>
<p>-في الحالات الأكثر تعقيدًا، يمكن للشركة اللجوء إلى خدمات تحصيل الديون و اتخاذ إجراءات قانونية لتحصيل المبالغ المستحقة .</p>
<p>-التأخير في السداد قد يؤثر على أي تعاملات مستقبلية مع العميل، بما في ذلك شروط دفع أكثر صرامة، أو متطلبات دفع مقدم أكبر في المستقبل .</p>
<p>-التأخير في السداد قد يؤثر على أي تعاملات مستقبلية مع العميل، بما في ذلك شروط دفع أكثر صرامة، أو متطلبات دفع مقدم أكبر في المستقبل .</p>
    </div>
<h3></h3>
    </div>
    </div>


}